/**
 * convert object to string
 * @param {any} obj object
 * @returns {string}
 */
function obj2str(obj) {
    if (Array.isArray(obj)) {
        return JSON.stringify(
            obj.map(function (idx) {
                return obj2str(idx)
            })
        )
    } else if (typeof obj === "object" && obj !== null) {
        var elements = Object.keys(obj)
            .sort()
            .map(function (key) {
                var val = obj2str(obj[key])
                if (val) {
                    return key + ":" + val
                }
            })

        var elementsCleaned = []
        for (var i = 0; i < elements.length; i++) {
            if (elements[i]) elementsCleaned.push(elements[i])
        }

        return "{" + elementsCleaned.join("|") + "}"
    }

    if (obj) return obj
}
/**
 *
 * @param {number} price
 * @param {number} vatPercent
 * @param {number} quantity
 * @param {boolean|string} localeString
 * @param {boolean} displayCurrency
 * @returns {number|string}
 */
function formatPrice(price, vatPercent = 0, quantity = 1, localeString = true, displayCurrency = false) {
    const currency = {
        code: "EUR",
        sign: "€",
        position: "left",
    }
    if (typeof price != "number" || isNaN(price)) return localeString ? "" : 0

    if (vatPercent) price *= vatPercent / 100 + 1

    const newPrice = (Math.round(price * 100) / 100) * quantity

    let _p

    try {
        _p = localeString
            ? newPrice.toLocaleString(typeof localeString == "string" ? localeString : "de", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
              })
            : newPrice
    } catch (e) {
        // ssr error
        _p = localeString ? newPrice.toFixed(2) : newPrice
    }
    if (displayCurrency) {
        // add currency
        if (currency.position == "left") {
            return currency.sign + " " + _p
        } else {
            return _p + " " + currency.sign
        }
    }
    return _p
}

/**
 *
 * @param {number} price
 * @param {number} vatPercent
 * @param {number} quantity
 * @returns {number}
 */
function formatPriceNumber(price, vatPercent = 0, quantity = 1) {
    // @ts-ignore
    return formatPrice(price, vatPercent, quantity, false)
}
module.exports = {
    obj2str,
    formatPrice,
    formatPriceNumber,
}
